import { IEnvironmentInfo, SHARED_LOGO_PATHS } from "@kiraah-shared/environment";

export type MobileEnvironment = IEnvironmentInfo;

export const environment: MobileEnvironment = {
  AuthenticationMode: "INTERNAL_PASSWORD",
  Environment: "INTEGRATION",
  Caching: {
    Enabled: true,
    InMemory: false,
  },
  DateTime: {
    StorageFormat: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
    DisplayFormats: {
      "fr-FR": "dd/MM/yyyy HH:mm:ss",
      "fr-CA": "dd/MM/yyyy HH:mm:ss",
      "en-GB": "dd/MM/yyyy HH:mm:ss",
      "en-US": "MM/dd/yyyy hh:mm:ss a",
      "es-ES": "dd/MM/yyyy HH:mm:ss",
      "de-DE": "dd.MM.yyyy HH:mm:ss",
      "it-IT": "dd/MM/yyyy HH:mm:ss",
      "pt-PT": "dd/MM/yyyy HH:mm:ss",
    },
    DefaultCulture: "fr-FR",
    SupportedCultures: ["fr-FR", "fr-CA", "en-US", "es-ES", "de-DE", "it-IT", "pt-PT"],
  },
  Api: {
    GatewayUrl: "https://int.gateway.kiraah.app",
  },
  WebAppUrl: "https://int.kiraah.app/#",
  MobilePwaUrl: "https://mobile.int.kiraah.app",
  InactivityDurationInMinutes: 30,
  WarningBeforeExpirationInMinutes: 2,
  Style: SHARED_LOGO_PATHS,
  DialogConfig: {
    ShowSuccess: true,
    ShowWarning: true,
    ShowError: true,
  },
  MobileAppDistribution: {
    apkUrl: "https://apk.int.kiraah.app/kiraah-mobile-int-apk/kiraah.int.apk",
    pwaUrl: "https://mobile.int.kiraah.app",
  },
};
